import { get } from 'lodash';
import { apiClientInstance, itv7ApiClientInstance } from './axiosClient';
import { metricsApi } from './metricsApi';

/**
 * Fetch product token from ITV7 API using UUID
 * @param {string} uuid - The one-time use UUID from the login callback
 * * @returns {Promise<{data: object|null, errorMessage: string|null}>} - Product token or error
 */
export const requestProductToken = async uuid => {
    let response;

    try {
        const { data } = await itv7ApiClientInstance.post('/sweeps/token', {
            uuid
        });

        response = {
            data: {
                productToken: data.productToken
            },
            errorMessage: null
        };
    } catch (err) {
        const errorMessage = err.message;

        response = {
            data: null,
            errorMessage
        };
        const statusCode = get(err, 'response.status', 500);

        await metricsApi.errorMetric(
            'requestProductToken',
            statusCode,
            errorMessage
        );
    }

    return response;
};

/**
 * Fetch user information using product token
 * @param {string} productToken - The product token from authentication
 * @returns {Promise<{data: object|null, errorMessage: string|null}>} - User info or error
 */
export const requestUserInfo = async productToken => {
    let response;

    try {
        const { data } = await apiClientInstance.get('/client/user/info', {
            headers: {
                Authorization: `Bearer ${productToken}`
            }
        });

        response = {
            data: {
                uki_customerid: data.customerId,
                given_name: data.givenName,
                family_name: data.familyName,
                'com.sbgcore.upgradable': data.upgradable,
                'com.sbgcore.can_link_to': data.canLinkTo
            },
            errorMessage: null
        };
    } catch (err) {
        const errorMessage = err.message;

        response = {
            data: null,
            errorMessage
        };
        const statusCode = get(err, 'response.status', 500);

        await metricsApi.errorMetric(
            'requestUserInfo',
            statusCode,
            errorMessage
        );
    }

    return response;
};
